import type { Level } from "../data/animals";
import { useT } from "../i18n/LocaleProvider";

interface Props {
  level: Level;
  onChange: (level: Level) => void;
}

// Difficulty options. The underlying level values stay 5/7/10 (used by the
// drawing data); these are just the friendly labels shown to the child.
const LEVELS: { level: Level; icon: string; key: "levelEasy" | "levelMedium" | "levelHarder" }[] = [
  { level: 5, icon: "🌱", key: "levelEasy" },
  { level: 7, icon: "🌟", key: "levelMedium" },
  { level: 10, icon: "🔥", key: "levelHarder" },
];

/** Difficulty picker. Any drawing can be attempted at any time. */
export function LevelSelector({ level, onChange }: Props) {
  const t = useT();
  return (
    <div className="level-selector" role="group" aria-label={t.chooseDifficulty}>
      {LEVELS.map((l) => (
        <button
          key={l.level}
          className={l.level === level ? "level-btn active" : "level-btn"}
          onClick={() => onChange(l.level)}
          aria-pressed={l.level === level}
          aria-label={t.levelDrawingsAria(t[l.key])}
        >
          <span className="level-icon" aria-hidden="true">
            {l.icon}
          </span>
          <span className="level-label">{t[l.key]}</span>
        </button>
      ))}
    </div>
  );
}
